<template>
  <div class="gate">
    <!--    <noscript>
      <div style="padding:24px">
      Для доступа к сайту нужен JavaScript. Если он отключён — вот статичная страница:
      <a href="/denied">Открыть</a>
      </div>
    </noscript>-->

    <div v-if="state==='show'">
      <div class="logo">
        <img src="@/assets/s-images/logo-sushiset-svg.svg" alt="">
      </div>

      <h1>
        Проверка доступа
      </h1>
      <p>
        Подтвердите, что вы не робот:
      </p>
      <div id="captcha-container" ref="captcha" style="margin-top:16px;" />
      <p v-if="error" style="color:#c00;margin-top:12px">
        {{ error }}
      </p>
    </div>

    <div v-else-if="state==='ok'">
      <p>Успех! Перехожу…</p>
    </div>

    <div v-else>
      <p>Загрузка…</p>
    </div>
  </div>
</template>

<script>

export default {
  layout: 'frame',
  data: () => ({
    state: 'show',
    error: '',
    _rendered: false,
  }),
  computed: {},
  mounted () {
    if (process.client) {
      this.$nextTick(function () {
        this.initCaptchaSafely()
      })
    }
  },

  methods: {
    async initCaptchaSafely () {
      if (this._rendered) {
        return
      }
      await this.$nextTick() // дождаться разметки из client-only
      const el = this.$refs.captcha
      if (!el) {
        requestAnimationFrame(() => this.initCaptchaSafely())
        return
      }
      try {
        await this.$smartcaptcha.ready() // убедиться, что скрипт загружен
        this.$smartcaptcha.render(el, {
          sitekey: this.$config.SMARTCAPTCHA_SITEKEY,
          callback: this.onToken,
        })
        this._rendered = true
      } catch (error) {
        console.error('error INIT CAPTCHA')
        console.error(error)
        setTimeout(() => this.initCaptchaSafely(), 2000)
      }
    },
    async onToken (token) {
      try {
        this.error = ''
        const res = await fetch('/bffapi/captcha/verify', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ token }),
        })
        if (!res.ok) {
          throw new Error('Сервер недоступен')
        }
        const data = await res.json()
        if (data.ok) {
          this.state = 'ok'
          const next = this.$route.query.next || '/'
          window.location.replace(next)
        } else {
          this.error = 'Проверка не пройдена. Попробуйте ещё раз.'
          this.$smartcaptcha.reset()
        }
      } catch (e) {
        this.error = e.message || 'Ошибка проверки. Повторите попытку.'
      }
    },
  },
}
</script>

<style scoped lang="less">

.gate {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 460px;
  margin: 48px auto;
  padding: 24px;
  //border: 1px solid #eee;
  border-radius: 12px;

  .logo {
    margin-bottom: 50px;
    text-align: center;

    img {
      max-width: 80%;
      width: 200px;
      height: auto;

      @media screen and (max-width: 992px) {
        width: 180px;
      }
    }
  }

  h1 {
    margin-bottom: 30px;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
  }

  p {
    margin-bottom: 30px;
    text-align: center;
  }
}
</style>
